import React, {useEffect, useState} from "react";
import styled from "styled-components";
import EventImg from "../../img/Event.png"
import { useCookies } from "react-cookie";

const Styled = {
    Wrap: styled.div`
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0px;
        background-color: #000000;
        opacity: 50%;
        z-index: 4;
    `,
    WrapBox: styled.div`
        width: 100%;
        height: 650px;
        background-color: #ffffff;
        position: fixed;
        top: auto;
        bottom: 0;
        z-index: 5;
        border-radius: 40px 40px 0px 0px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
    `,
    ConTentWrap: styled.div`
        width: 100%;
        height: 561px;
        background-color: #2277F6;
        border-radius: 40px 40px 0px 0px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    `,
        ContendImg:styled.img`
            width:360px;
            height:561px;
            border-radius: 40px 40px 0px 0px;
        `,
    Footer: styled.div`
        width: 100%;
        height: 89px;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: row;
    `,
        FooterContentWrap:styled.div`
            width:90%;
            height:59px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: row;
        `,
            CloseTodayBtn:styled.p`
                font-size:16px;
                font-weight:400;
                margin:0px;
                font-family:'PreFont';
                color:#181818;
                letter-spacing:-0.33px;
            `,
            CloseBtn:styled.p`
                font-size:16px;
                font-weight:400;
                margin:0px;
                font-family:'PreFont';
                color:#181818;
                letter-spacing:-0.33px;
            `,
  };
const EventCompo=(props)=>{
    const {CallOpen, setCallOpen, NowLang} = props
    const [cookies, setCookie] = useCookies(["eventClosed"]);
    useEffect(() => {
        // 쿠키가 있으면 이벤트를 숨김
        const eventClosed = cookies.eventClosed;
        if (eventClosed && new Date().getTime() < eventClosed) {
            setCallOpen(false); // 3시간 이내면 이벤트를 숨김
        }
    }, [cookies]);

    const handleCloseToday = () => {
        // 3시간 후에 이벤트가 보이지 않도록 쿠키에 설정
        const threeHoursLater = new Date().getTime() + 3 * 60 * 60 * 1000; // 3시간 후
        setCookie("eventClosed", threeHoursLater, { path: "/" }); // 쿠키 설정
        setCallOpen(false); // 이벤트 숨김
    };

    if(CallOpen === false){
        return(
            <></>
        )
    }else{
        return(
            <>
                <Styled.Wrap onClick={()=>{setCallOpen(false)}}/>
                <Styled.WrapBox>
                    <Styled.ConTentWrap>
                        <Styled.ContendImg 
                            src={EventImg}
                            onClick={() => window.open("https://m.place.naver.com/my/checkin", "_blank", "noopener,noreferrer")}    
                        />
                    </Styled.ConTentWrap>
                    <Styled.Footer>
                        <Styled.FooterContentWrap>
                            <Styled.CloseTodayBtn onClick={handleCloseToday}>오늘 그만보기</Styled.CloseTodayBtn>
                            <Styled.CloseBtn onClick={()=>{setCallOpen(false)}}>닫기</Styled.CloseBtn>
                        </Styled.FooterContentWrap>
                    </Styled.Footer>
                </Styled.WrapBox>
            </>
        )
    }
    
}
export default EventCompo